import { BaseModel } from "./base/base.model";

export class AppSolicitudesBolsa extends BaseModel {
    public holidayBag1?: string;
    public requestedAmount?: number;
    public currentAmount?: number;
    public state?: number;
}